import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const getFinancialHistoryUserInfo = async (
    ctx: QueryFunctionContext
) => {
    const { data }: { data: FinancialHistoryUser } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/poolships/${ctx.queryKey[2]}/`
    )
    return data
}

export const getCashinAndCashout = async (ctx: QueryFunctionContext) => {
    const { data }: { data: { result: Array<ICashinCashoutFinancial> } } =
        await request.get(
            `/moneypool_management/${ctx.queryKey[1]}/poolship/cashins-and-cashouts/`
        )
    return data
}

export const getFinancialLoans = async (
    pageParam: number,
    pool: string | undefined,
    ship: string | undefined
) => {
    const { data }: { data: IGetFinancialLoans } = await request.get(
        `/api/v1/moneypools/${pool}/loans/?poolship_id=${ship}&page=${pageParam}`
    )
    return data
}
